export const resources_mobile_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            //
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/mobile_horizontal/only_this_mode/hand.png",

            "res/mobile_horizontal/utility_background.png",
            "res/mobile_horizontal/frame_ui.png",
            "res/mobile_horizontal/frame_total_bet.png",

            "res/mobile_horizontal/back/background_0.jpg",
            "res/mobile_horizontal/back/background_1.jpg",
            "res/mobile_horizontal/back/background_2.jpg",
            "res/mobile_horizontal/back/background_3.jpg",
            "res/mobile_horizontal/back/background_4.jpg",
            "res/mobile_horizontal/back/background_5.jpg",

            "res/mobile_horizontal/utility_common.json",
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/mobile_horizontal/resources.es6
// module id = 123
// module chunks = 0